module.exports = __webpack_public_path__ + "img/zixun1.6446588d.png";